import gql from 'graphql-tag'

const query = gql`
query listSalesGroups($params: ListQueryArgs) {
	cashAssist {
		listSalesGroups(params: $params) {
			items {
				id
				name
				acountNum
			}
			hasNextPage
		}
	}
}`

export default query
